<div class="h-100 d-flex justify-content-center align-items-center">
  <mat-card
    appearance="outlined"
    style="border-radius: 12px; min-width: 800px; height: 650px; min-height: 400px"
    class="m-5 p-4 pending-approval__card"
  >
    <div class="text-center">
      <mat-icon>access_time</mat-icon>
    </div>
    <h2
      class="subheadline font-size-headline5 text-darker"
      style="max-width: 500px"
      data-testid="pending-approval-title-selector"
    >
      Your Shop access request has been received and is being handled by your Account Representative. You'll be notified
      via email, once access is ready
    </h2>
    <div class="d-flex justify-content-center align-items-center">
      <button
        data-testid="pending-approval-button-selector"
        class="my-2"
        color="primary"
        mat-stroked-button
        (click)="returnToHomePage()"
      >
        Return to Home Page
      </button>
    </div>
  </mat-card>
</div>
